import util from '@bmp-vue/core/api/util'

const controller = 'AprovacaoTransacao'

export default Object.assign({}, util.GetCrud(controller, ['get', 'getall']), {
  GetMovimentosEmAnalise: function (dto) {
    return util.Axios.GetAll(controller + '/MovimentosEmAnalise', dto)
  },
  DetalhesTransacao: function (id) {
    return util.Axios.Get(controller + '/DetalhesTransacao', id)
  },
  Operadores: function (id) {
    return util.Axios.Get(controller + '/OperadoresAprovadores', id)
  },
  ReprovarTransacao: function (id) {
    return util.Axios.Put(controller + '/ReprovarTransacao', id)
  },
  ObterAutorizacaoTransacionalCartao: function (dto) {
    return util.Axios.GetAll(controller + '/AutorizacaoTransacionalCartao', dto)
  }  
})
